import { render, staticRenderFns } from "./Questionnaire.vue?vue&type=template&id=584a5451&scoped=true&"
import script from "./Questionnaire.vue?vue&type=script&lang=js&"
export * from "./Questionnaire.vue?vue&type=script&lang=js&"
import style0 from "./Questionnaire.vue?vue&type=style&index=0&id=584a5451&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584a5451",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('584a5451')) {
      api.createRecord('584a5451', component.options)
    } else {
      api.reload('584a5451', component.options)
    }
    module.hot.accept("./Questionnaire.vue?vue&type=template&id=584a5451&scoped=true&", function () {
      api.rerender('584a5451', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/illicit-barcode/campaign/components/Questionnaire.vue"
export default component.exports